import { Country, countryListValid } from '@/models/country';

/** Example ranked list for Rules page preview: 4 seeds, 6 middles, 2 outsiders. */
export const RULES_DEMO_COUNTRY_LIST: Country[] = [
  Country.ES,
  Country.US,
  Country.BR,
  Country.FR,
  Country.CO,
  Country.JP,
  Country.HR,
  Country.MA,
  Country.GH,
  Country.NZ,
];

if (!countryListValid(RULES_DEMO_COUNTRY_LIST)) {
  console.error('RULES_DEMO_COUNTRY_LIST failed countryListValid — update the demo list.');
}
